import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import appConfig from '../../appConfig';
import { disableRightClick } from '../../utils/uiUtils';
import CloseIcon from '../Icons/CloseIcon';
import Loader from '../ui/Loader';

const OBJViewer = lazy(() => import('../OBJViewer/index'));

function UMODetailViewFullImage({
  isFullImageShown,
  onFullImageToggle,
  umoData,
}) {
  if (!umoData || !umoData.fullSrc || !umoData.type) {
    return null;
  }
  const webQualityType = umoData.umo.type || umoData.umo.webQuality.type;
  const webQualityURL = umoData.umo.webQuality
    ? umoData.umo.webQuality.url
    : umoData.umo.thumbnail.url;
  const host = umoData.fullSrc.includes('/wds/') ? '' : appConfig.hostURL;
  let img = '';
  const original = umoData.umo.originalList.all[0]
    ? umoData.umo.originalList.all.filter((i) => i.index === '1')[0]
    : null;
  if (webQualityType == 'HTML' || webQualityType == 'DOCUMENT') {
    if (original) {
      const host = original._data.$.h.includes('/wds/')
        ? appConfig.cardURL
        : appConfig.hostURL;
      if (original.mimeType.includes('stl')) {
        img = (
          <Suspense fallback={<Loader />}>
            <OBJViewer
              url={original.url}
              width={0.7 * window.innerWidth}
              height={0.8 * window.innerHeight}
              fileName={original.fileName}
              umoId={original.id}
              isStlModel={true}
            />
          </Suspense>
        );
      } else if (original.mimeType.includes('octet-stream')) {
        img = (
          <Suspense fallback={<Loader />}>
            <OBJViewer
              url={original.url}
              width={0.7 * window.innerWidth}
              height={0.8 * window.innerHeight}
              fileName={original.fileName}
              umoId={original.id}
              isStlModel={false}
            />
          </Suspense>
        );
      } else {
        img = (
          <iframe
            className="umo-media-view__html"
            src={host + original._data.$.h}
          />
        );
      }
    } else {
      // in case no download rules exist for this type of media
      img = (
        <img
          className="umo-media-view__image"
          alt={umoData.umo.name}
          src={webQualityURL}
          loader={<Loader />}
          onContextMenu={disableRightClick}
        />
      );
    }
  } else if (umoData.type === 'PHOTO') {
    img = appConfig.useZoomify ? (
      <iframe
        className="umo-grid-item__fullscreen-zoomify-display"
        src={appConfig.hostURL + umoData.zoomifyURL}
      />
    ) : (
      <img
        className="umo-grid-item__fullscreen-image-display"
        alt=""
        src={umoData.fullSrc}
        onContextMenu={disableRightClick}
      />
    );
  } else {
    img = (
      <iframe
        className="umo-media-view__html"
        src={host + umoData.fullSrc}
        onContextMenu={disableRightClick}
      />
    );
  }
  return (
    <div className="umo-grid-item__fullscreen">
      <Modal
        show={isFullImageShown}
        onHide={() => onFullImageToggle(false)}
        dialogClassName="umo-grid-item__fullscreen-overlay"
        backdropClassName="umo-grid-item__fullscreen-backdrop"
      >
        <div className="umo-grid-item__fullscreen-image">
          <CloseIcon
            width={24}
            height={24}
            aria-label="Close"
            onClick={() => onFullImageToggle(false)}
            stroke="#FFF"
            className="umo-grid-item__fullscreen-image-close-icon"
          />
          {img}
          <span
            onClick={() => {
              onFullImageToggle(false);
            }}
            className="umo-grid-item__fullscreen-image-fullscreen-button"
          />
        </div>
      </Modal>
    </div>
  );
}

UMODetailViewFullImage.propTypes = {
  isFullImageShown: PropTypes.bool,
  onFullImageToggle: PropTypes.func,
  umoData: PropTypes.instanceOf(Object),
};

export default UMODetailViewFullImage;
